import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import TreeItemContainer from '@/common/components/ModalTreeItem/TreeItemContainer/TreeItemContainer';
import TreeItemInput from '@/common/components/ModalTreeItem/TreeItemInput/TreeItemInput';
function ModalTreeItem(props) {
    const { value, onChange, isPendingCreation, isSelected, isEdited, icon, save, className } = props;
    return (_jsxs(TreeItemContainer, { isSelected: isSelected, className: className, children: [icon, isEdited ? (_jsx(TreeItemInput, { onChange: onChange, isPendingCreation: isPendingCreation, value: value, isSelected: isSelected, save: save })) : (value)] }));
}
export default observer(ModalTreeItem);
